import { createClient } from "@connectrpc/connect";
import { IDeleteService } from "../../../../abstractions/services/actions/IDeleteService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { MonitoreoRelacionFincaCultivoPlagaService } from "../../../../generated/grpc/configuracion_monitoreo_pb";
import { grpcMonitoreoRelacionFincaCultivoPlagaDatabase } from "../database/GrpcMonitoreoRelacionFincaCultivoPlagaDatabase";
import { MonitoreoRelacionFincaCultivoPlagaResponse } from "../response/MonitoreoRelacionFincaCultivoPlagaResponse";

/** Variante gRPC-Web de `MonitoreoRelacionFincaCultivoPlagaDeleteService`
 *  (ver ese archivo): apagar una plaga en la UI es borrar su relación, no hay
 *  estado intermedio. */
export class MonitoreoRelacionFincaCultivoPlagaDeleteGrpcService
  implements IDeleteService<MonitoreoRelacionFincaCultivoPlagaResponse>
{
  async deleteAsync(
    item: MonitoreoRelacionFincaCultivoPlagaResponse,
  ): Promise<void> {
    const client = createClient(
      MonitoreoRelacionFincaCultivoPlagaService,
      grpcTransportProvider.get(),
    );

    try {
      await client.eliminar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcMonitoreoRelacionFincaCultivoPlagaDatabase.deleteOneAsync(item.id);
  }
}

/** Instancia única del servicio gRPC de baja de relaciones. */
export const monitoreoRelacionFincaCultivoPlagaDeleteGrpcService =
  new MonitoreoRelacionFincaCultivoPlagaDeleteGrpcService();
